import { type MouseEvent, type ReactNode, useMemo } from 'react';

export type ChipTabProps = {
  label: ReactNode;
  selected?: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  count?: number;
  disabled?: boolean;
  size?: 'small' | 'medium';
  id?: string;
  'data-testid'?: string;
  className?: never;
  sx?: never;
  style?: never;
};

export function useChipTab(props: ChipTabProps) {
  const isSelected = Boolean(props.selected);

  const displayLabel = useMemo(() => {
    if (props.count !== undefined) {
      return `${props.label} (${props.count})`;
    }
    return props.label;
  }, [props.label, props.count]);

  const variant: 'filled' | 'outlined' = isSelected ? 'filled' : 'outlined';
  const size = props.size ?? 'small';

  function handleClick(event: MouseEvent<HTMLElement>) {
    if (props.disabled) {
      return;
    }
    props.onClick?.(event);
  }

  return {
    isSelected,
    displayLabel,
    variant,
    size,
    handleClick,
  };
}
